import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../../../generic-components/Layout';
import {
  STYLES, CARD_PRETTY_STATUS, SHIPPING_STATUS, PROGRESS_STEPS, TEXTS,
} from '../constants/index';
import ContentWrapper from '../../../generic-components/ContentWrapper';
import MainContent from '../../../generic-components/Layout/MainContent';
import { useStore } from '../../../store';
import { getMostRelevantCard } from '../../../helpers/cardStatus.helper';
import { TrackerStepContainer } from '../components/TrackerStepContainer';
import Icon from '../../../generic-components/Icon';
import CardTrackerIcon from '../../../assets/icons/svg/stamp-icons/ic-stamp-location.svg';
import Heading from '../../../generic-components/Heading';
import { TrackerActions } from '../components/TrackerActions';
import { VIEWS_MAP } from '../../../router/constants';

const {
  APP_LAYOUT: { LAYOUT, TITLE, NAV }, MAIN_CONTENT_WRAPPER, ICON, HEADING,
} = STYLES;

const {
  RETURN_TO_SENDER, NEEDS_FUND, CARD_ON_PRINT, ACTIVATION_REQUIRED, SHIPPING, UNKNOWN,
} = CARD_PRETTY_STATUS;

const { RTS } = SHIPPING_STATUS;

const CardTracker = () => {
  const summaryData = useStore(state => state.summary);
  const { getPersonalAccount } = useStore(state => state);
  const [isFlowEligible, setIsFlowEligible] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState<number>(0);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const mostRelevantCard = useMemo(() => getMostRelevantCard(getPersonalAccount()?.cards), [summaryData]);

  const activeStepActions = useMemo(() => {
    const activeStepObj = PROGRESS_STEPS.find(s => s.statusRef === activeStep);
    if (!activeStepObj) return [];
    return activeStepObj.actions;
  }, [activeStep]);

  const getActiveStep = () => {
    if (!mostRelevantCard) return UNKNOWN;
    if (mostRelevantCard.prettyStatus !== ACTIVATION_REQUIRED) {
      return mostRelevantCard.prettyStatus;
    }
    if (mostRelevantCard.shippingStatus === RTS) {
      return RETURN_TO_SENDER;
    }
    if (mostRelevantCard.shippingDate && new Date() > new Date(mostRelevantCard.shippingDate)) {
      return ACTIVATION_REQUIRED;
    }
    return SHIPPING;
  };

  const checkFlowEligibility = () => {
    const validStatuses = [RETURN_TO_SENDER, NEEDS_FUND, CARD_ON_PRINT, ACTIVATION_REQUIRED];
    if (mostRelevantCard && mostRelevantCard.prettyStatus && validStatuses.includes(mostRelevantCard.prettyStatus)) {
      setIsFlowEligible(true);
      setActiveStep(getActiveStep() || UNKNOWN);
    } else {
      // TODO ask Robi, should we add a info popup ?
      navigate(`/${VIEWS_MAP.DASHBOARD}`);
    }
  };

  useEffect(() => {
    checkFlowEligibility();
  }, [mostRelevantCard]);

  return (
    <AppLayout layoutStyle={LAYOUT} titleStyle={TITLE} navBarStyle={NAV} title={t(TEXTS.ROUTE_TITLE)}>
      <ContentWrapper>
        {isFlowEligible && (
        <MainContent className={MAIN_CONTENT_WRAPPER}>
          <Icon className={ICON} src={CardTrackerIcon} />
          <Heading title={t(TEXTS.HEADING)} className={HEADING} />
          <TrackerStepContainer shippingDate={mostRelevantCard?.shippingDate || null} steps={PROGRESS_STEPS} activeStep={activeStep} />
          <TrackerActions activeStep={activeStep} activeStepActions={activeStepActions} />
        </MainContent>
        )}
      </ContentWrapper>
    </AppLayout>
  );
};

export default CardTracker;
